module.exports = __webpack_public_path__ + "img/coupon_yk_bg2.6d88e6b7.webp";